import React, { useEffect, useRef, useState } from "react";
import {
  Chart,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  LineController,
} from "chart.js";
import { useHistory } from "react-router";

Chart.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  LineController
);

export default function CardLineChart({ info,systemSettings }) {
  const history = useHistory();
  const [isDataVisible, setIsDataVisible] = useState(true);
  const [isScratched, setIsScratched] = useState(false);

  const chartRef = useRef(null); // Define chartRef
  const canvasRef = useRef(null); // Define canvasRef

  const programs = Array.isArray(info?.data) ? info.data : [];

  const counts = {
    incoming: programs.filter((p) => p.status === "incoming").length,
    inProgress: programs.filter((p) => p.status === "in-progress").length,
    completed: programs.filter((p) => p.status === "completed").length,
    overdue: programs.filter((p) => p.status === "overdue").length,
  };

  const config = {
    type: "line",
    data: {
      labels: ["Incoming", "In Progress", "Completed", "Overdue"],
      datasets: [
        {
          label: "Programs",
          data: [
            counts.incoming,
            counts.inProgress,
            counts.completed,
            counts.overdue,
          ],
          borderColor: "#ffa710",
          backgroundColor: "white",
          fill: false,
          order: 10,
          tension: 0.4, // Make the line curved
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: (tooltipItem) => {
              const value = tooltipItem?.raw ?? 0;
              return `Value: ${value}`;
            },
          },
        },
      },
      onClick: (event, elements, chart) => {
        if (elements.length > 0) {
          const index = elements[0].index; // Get the index of the clicked dot
          const statusMap = ["incoming", "in-progress", "completed", "overdue"];
          const status = statusMap[index] || "unknown";
          history.push("/admin/projects", { state: { status } }); // Pass status in `state`
        }
      },
      scales: {
        x: {
          ticks: {
            color: "rgba(255,255,255,.8)",
          },
          grid: {
            display: false,
            drawBorder: false,
            color: "#064163",
          },
        },
        y: {
          ticks: {
            color: "white",
            stepSize: 1,
          },
          grid: {
            display: true,
            borderDash: [3],
            color: "rgba(255, 255, 255, 0.15)",
            drawBorder: false,
          },
        },
      },
    },
  };

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.destroy(); // Destroy the previous chart instance
    }

    const ctx = canvasRef.current.getContext("2d");
    chartRef.current = new Chart(ctx, config); // Initialize the chart

    return () => {
      chartRef.current?.destroy(); // Cleanup on unmount
    };
  }, [info]); // Re-render chart when `info` changes

  const handleLegendClick = () => {
    setIsDataVisible(!isDataVisible);
    setIsScratched(!isScratched);
    history.push("/admin/projects", {
      status: "all",
    });
  };

  return (
    <>
      <div
        onClick={handleLegendClick}
        className="relative flex flex-col min-w-0 p-2 break-words w-full mb-6 shadow-lg rounded"
        style={{backgroundColor:systemSettings?.mainBackground}}
      >
        <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
          <div className="flex items-center justify-between">
            <h2 className="text-white text-lg mb-0">Overall Project Status</h2>
          </div>
        </div>
        <div className="p-3 flex-auto">
          <div className="relative h-300-px">
            <canvas ref={canvasRef}></canvas> {/* Attach canvasRef */}
          </div>
        </div>
      </div>
    </>
  );
}
